export const CREDIT_CIBIL_LOADING = 'CREDIT_CIBIL_LOADING';
export const CREDIT_CIBIL_SUCCESS = 'CREDIT_CIBIL_SUCCESS';
export const CREDIT_CIBIL_FAILED = 'CREDIT_CIBIL_FAILED';
export const SEND_OTP_CIBIL_LOADING = "SEND_OTP_CIBIL_LOADING";
export const SEND_OTP_CIBIL_SUCCESS = "SEND_OTP_CIBIL_SUCCESS";
export const SEND_OTP_CIBIL_FAILED = "SEND_OTP_CIBIL_FAILED";
export const VALIDATE_OTP_LOADING = 'VALIDATE_OTP_LOADING';
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAILED = 'VALIDATE_OTP_FAILED';
export const SAVE_CIBIL_LOADING = 'SAVE_CIBIL_LOADING';
export const SAVE_CIBIL_SUCCESS = 'SAVE_CIBIL_SUCCESS';
export const SAVE_CIBIL_FAILED = 'SAVE_CIBIL_FAILED';
export const SAVE_ALTERNATE_MOBILE_LOADING = 'SAVE_ALTERNATE_MOBILE_LOADING';
export const SAVE_ALTERNATE_MOBILE_SUCCESS = 'SAVE_ALTERNATE_MOBILE_SUCCESS';
export const SAVE_ALTERNATE_MOBILE_FAILED = 'SAVE_ALTERNATE_MOBILE_FAILED';
export const SAVE_SKIP_LOADING = 'SAVE_SKIP_LOADING';
export const SAVE_SKIP_SUCCESS = 'SAVE_SKIP_SUCCESS';
export const SAVE_SKIP_FAILED = 'SAVE_SKIP_FAILED';
export const VERIFY_ANSWERS_LOADING = 'VERIFY_ANSWERS_LOADING';
export const VERIFY_ANSWERS_SUCCESS = 'VERIFY_ANSWERS_SUCCESS';
export const VERIFY_ANSWERS_FAILED = 'VERIFY_ANSWERS_FAILED';

